import { Plus, Calendar } from 'lucide-react'

export default function Plans() {
  return (
    <div className="p-4 md:p-6 max-w-4xl mx-auto space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-semibold">Плани</h1>
          <p className="text-slate-400 text-sm mt-0.5">Розклад і завдання</p>
        </div>
        <button className="btn-primary flex items-center gap-2">
          <Plus size={18} />
          Новий план
        </button>
      </div>

      <div className="card p-5">
        <div className="flex items-center gap-2 mb-4">
          <Calendar size={18} className="text-violet-400" />
          <h2 className="font-medium">Сьогодні, 15 травня</h2>
        </div>
        <div className="space-y-3">
          {[
            { title: 'Тренування в залі', time: '08:00 – 09:00', done: true },
            { title: 'Зустріч з клієнтом', time: '11:00 – 12:00', done: true, location: 'Офіс / Переговорна 2' },
            { title: 'Зустріч з Андрієм', time: '14:00 – 15:00', done: false, location: 'Офіс / Переговорна 2' },
            { title: 'Підготувати звіт', time: '15:00', done: false },
            { title: 'Почитати книгу', time: '21:00', done: false },
          ].map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-3 p-3 rounded-xl bg-slate-800/40"
            >
              <div
                className={`mt-0.5 w-5 h-5 rounded border flex items-center justify-center shrink-0 ${
                  item.done ? 'bg-emerald-500 border-emerald-500' : 'border-slate-600'
                }`}
              >
                {item.done && (
                  <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                    <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
                  </svg>
                )}
              </div>
              <div className="flex-1">
                <div className={`font-medium text-sm ${item.done ? 'text-slate-500 line-through' : ''}`}>
                  {item.title}
                </div>
                <div className="text-xs text-slate-500 mt-0.5">{item.time}</div>
                {item.location && (
                  <div className="text-xs text-slate-500 mt-0.5">📍 {item.location}</div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
